import './Evoke.css';

interface GameLayoutProps {
  children: React.ReactNode;
}

export default function GameLayout({ children }: GameLayoutProps) {
  return (
    <div className="evoke-ui ev-table-scene">
      <div className="ev-table-grain" aria-hidden="true" />
      <div className="ev-table-content">{children}</div>
    </div>
  );
}
